export default {
  Title : 'Delivery Staff | Delivery Staff | Delivery Staff',
  Button: {
    DeliveryStaff: {
      Add: {
        Title: 'Add Delivery Staff',
        Color: 'primary',
        Icon : 'add_box'
      },
      Edit: {
        Color: 'grey lighten-0',
        Icon : 'edit'
      },
      Delete: {
        PopUp: {
          Title  : 'Delete delivery staff?',
          Content: 'Are you sure you want to permanently delete this delivery staff?'
        }
      }
    },
    RemoveOrder: {
      PopUp: {
        Title  : 'Remove order?',
        Content: 'Are you sure you want to remove this order from the delivery staff\'s shift?'
      }
    },
    Shift: {
      Open: {
        Title: 'Start shift',
        Color: 'green',
        Icon : 'fas fa-plus-circle',
        PopUp: {
          Title : 'Shift Start Amount',
          Hint  : 'The amount with which the shift starts.',
          Button: 'Start'
        }
      },
      Close: {
        Title: 'End shift',
        Color: 'red',
        Icon : 'fas fa-times-circle',
        PopUp: {
          Title                : 'End shift?',
          Content              : 'Are you sure you want to end this shift?',
          CompletedCardPayments: 'Card orders with completed payment | Card order with completed payment | Card orders with completed payment',
          PendingCardPayments  : 'Card orders without payment | Card order without payment | Card orders without payment',
          WithoutFiscalDoc     : 'Orders without fiscal doc | Order without fiscal doc | Orders without fiscal doc'
        }
      }
    }
  },

  ListView: {
    NoData: {
      Title   : 'Create Delivery Staff',
      Subtitle: 'Add New Delivery Staff',
      Icon    : 'account_circle'
    },
    SelectDeliveryStaff: {
      Title   : 'Select delivery staff',
      Subtitle: 'Select delivery staff from the list',
      Icon    : 'directions_bike'
    },
    Table: {
      Headers: {
        DateStarted: 'Date',
        Swifts     : 'Swifts',
        Orders     : 'Orders',
        Total      : 'Total',
        Actions    : ''
      }
    }
  },

  Common: {
    Orders      : 'Orders',
    ShiftsOrders: 'Shift\'s Orders: ',
    ShiftStart  : 'Start of shift',
    ShiftTotal  : 'Total amount of shift',
    InfoLabels  : {
      Icon     : 'account_circle',
      Telephone: 'Tel.:',
      Email    : 'Email:'
    }
  },

  UserDashboard: {
    Tab: {
      Added: {
        Title : 'ACCEPT',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'No orders to accept',
          Subtitle: ''
        }
      },
      Accepted: {
        Title : 'ADD',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'No orders to add',
          Subtitle: ''
        }
      },
      Received: {
        Title : 'DELIVER',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'No orders to deliver',
          Subtitle: ''
        }
      },
      Completed: {
        Title : 'COMPLETED',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'No completed orders',
          Subtitle: ''
        }
      },
      UnPaid: {
        Title : 'UNPAID',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'No unpaid orders',
          Subtitle: ''
        }
      },
      Paid: {
        Title : 'PAID',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'No paid orders',
          Subtitle: ''
        }
      }
    },
    Message: {
      Notify: {
        Success: 'Notification for order #{orderCode} has been sent.'
      }
    },
    Button: {
      Map       : 'Map',
      Directions: 'Directions',
      Accepted  : 'Accept',
      Declined  : 'Decline',
      Received  : 'Receive',
      Delivered : 'Complete'
    }
  },

  DeliveryOrderStatus: {
    Added: {
      Label: 'Assigned',
      Color: 'grey',
      Icon : 'mdi-account-plus'
    },
    Accepted: {
      Label: 'Accepted',
      Color: 'blue',
      Icon : 'mdi-account-check'
    },
    Received: {
      Label: 'Delivering',
      Color: 'purple',
      Icon : 'mdi-progress-clock'
    },
    Delivered: {
      Label: 'Delivered',
      Color: 'success',
      Icon : 'mdi-package-variant-closed-check'
    }
  },

  DeliveryUser: {
    Warning : 'The delivery staff user will be permanently deleted!',
    Settings: {
      Title       : 'Settings',
      CanOpenShift: {
        Title   : 'Open shift',
        Subtitle: 'Open delivery staff shift'
      },
      CanCloseShift: {
        Title   : 'Close shift',
        Subtitle: 'Close delivery staff shift'
      },
      CanAddOrder: {
        Title   : 'Add Order',
        Subtitle: 'Add order to the shift'
      },
      CanDeleteOrder: {
        Title   : 'Remove Order',
        Subtitle: 'Remove order from the shift'
      },
      CanTransactionSale: {
        Title   : 'Card charge',
        Subtitle: 'Customer card charge and issue receipt'
      },
      CanGenerateDocument: {
        Title   : 'Generate Receipt',
        Subtitle: 'Issue Fiscal Document (Receipt)'
      },
      IsGenerateDocumentRequired: {
        Title   : 'Generate Receipt Required',
        Subtitle: 'Required to Issue Fiscal Document (Receipt)'
      },
      CanPrintDocument: {
        Title   : 'Print Receipt',
        Subtitle: 'Print Fiscal Document (Receipt)'
      },
      CanTransactionRefund: {
        Title   : 'Card refund',
        Subtitle: 'Refund to Customer Card'
      },
      TrackLocation: {
        Title   : 'Delivery staff monitoring on map',
        Subtitle: 'Watch the geographical location of the delivery staff on map'
      }
    }
  },

  DeliveryStaffInfo: {
    Tab: {
      Details: '@:Common.Misc.Details',
      History: 'History'
    },
    Button: {
      AddOrder: {
        Title: 'Add order',
        Color: 'light-green'
      },
      ViewDailyShift: {
        Title: 'View daily shifts',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      }
    },
    Result: {
      NoOrders     : 'There are no shift orders yet',
      NoOrdersShift: {
        Title   : 'There are no shift orders',
        Subtitle: 'Add a new order',
        Icon    : 'shopping_cart'
      },
      InactiveShift: {
        Icon         : 'directions_bike',
        Title        : 'Inactive shift',
        SubtitleLink : 'Start',
        SubtitleText : 'delivery staff\'s shift',
        SubtitleText2: 'Ask manager to start your shift'
      }
    }
  },

  PrintDeliveryShift: {
    PrintReceipt: {
      StartShift  : 'Start of Shift',
      Delivery    : 'Delivery',
      Collection  : 'Collection',
      Canceled    : 'Canceled',
      Cash        : 'Cash',
      Card        : 'Card',
      WithoutStart: 'Without Start:',
      NotIncluded : 'Not Included',
      ByCard      : ' by Card ('
    },
    Notification: 'The shift was sent for printing!'
  },

  DeliveryStaffAddDialog: {
    Toolbar: {
      Color: 'indigo',
      Icon : 'directions_bike',
      Add  : {
        Title   : 'Add Delivery Staff',
        Subtitle: 'Create New Delivery Staff'
      },
      Edit: {
        Title   : 'Edit Delivery Staff',
        Subtitle: 'Edit Delivery Staff Details'
      }
    },
    Field: {
      Firstname: {
        Label: 'First Name',
        Hint : 'Delivery Staff\'s First Name. eg. George, Jane, etc.',
        Icon : 'account_circle',
        Error: {
          Between: 'First Name must be between 2 and 32 characters'
        }
      },
      Lastname: {
        Label: 'Last Name',
        Hint : 'Delivery Staff\'s Last Name. eg. Smith, Doe, etc.',
        Icon : 'account_circle',
        Error: {
          Between: 'Last Name must be between 2 and 32 characters'
        }
      },
      Telephone: {
        Label: 'Telephone',
        Hint : 'Delivery Staff\'s telephone number eg. 2106105200',
        Icon : 'phone',
        Error: {
          Between: 'Telephone number must be between 8 and 16 digits'
        }
      },
      Email: {
        Label: 'Email',
        Hint : 'Delivery Staff\'s email address eg. support@getfoodpro.gr',
        Icon : 'email',
        Error: {
          Between: 'E-mail  must be up to 96 characters long',
          Valid  : 'E-mail must be valid'
        }
      },
      Notes: {
        Label: 'Notes',
        Hint : 'Delivery Staff\'s additional info',
        Icon : 'speaker_notes'
      }
    }
  },

  DeliveryStaffDayShiftsDialog: {
    Header: {
      Icon : 'directions_bike',
      Title: 'Delivery Staff\'s Daily Shifts',
      Shift: 'Shift'
    },
    Result: {
      NoOrders: {
        Icon    : 'shopping_cart',
        Color   : 'grey lighten-2',
        Title   : 'There are no orders',
        Subtitle: 'There are no orders in the delivery staff\'s shift'
      }
    }
  },

  SelectDeliveryStaffDialog: {
    Toolbar: {
      Icon    : 'directions_bike',
      Subtitle: 'Delivery Staff Selection'
    },
    Result: {
      NoDeliveryStaff: {
        Title   : 'There are no Delivery Staff',
        Subtitle: {
          Please       : 'Please',
          Open         : 'open',
          ShiftOr      : 'shift or',
          Create       : 'create',
          DeliveryStaff: 'delivery staff'
        }
      }
    }
  },

  DeliveryStaffBarcode: {
    OnBarcodeScan: {
      Error: {
        Title: 'Order Barcode #',
        Body : 'The order was not added! Please scan the delivery staff barcode first!'
      },
      SetActiveDeliveryStaff: {
        Add: {
          Body: 'Start receiving orders for delivery staff. Please scan order barcode.'
        },
        ClosedShift: {
          Title: 'Delivery Staff Barcode',
          Body : 'Delivery Staff {firstname} {lastname} does not have an open shift. Please open shift first.'
        },
        NotFound: {
          Title: 'Delivery Staff Barcode',
          Body : 'The barcode does not correspond to delivery staff!'
        }
      },
      ClearActiveDeliveryStaff: {
        Body: 'End receiving orders for delivery staff.'
      }
    }
  }
}
